// date should be a date object created using the new Date() constructor
export const createShortDate = (date: Date) => {
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0"); // Months are zero-indexed, so add 1.
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
    
}